define('plugin/social-gallery/view/SocialGalleryModuleItemView',['require','lib/view/LayoutView'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    /**
     * Gallery item view
     *
     * @class SocialGalleryModuleItemView
     */
    return LayoutView.extend({

        template: '#social_gallery_module_item_view',

        ui : {
            link : 'a.image-item-container.video-item'
        },

        events : {
            'mouseenter @ui.link' : 'onVideoHover',
            'mouseleave @ui.link' : 'onVideoLeave',

        },

        onRender : function(){
        },

        initialize: function () {
            //* @todo why parent initialize() is not called?
        },

        onVideoHover : function () {
 /*           if(!this.isVideoSupport('h264')){
                return false;
            }*/

            var $video = this.ui.link.find('video');
            var $image = this.ui.link.find('.img-item');

            var height = $image.height();

            if(height < parseInt($image.css('padding-bottom'))){
                height = $image.css('padding-bottom');
            }
            if(height < parseInt($image.css('padding-top'))){
                height = $image.css('padding-top');
            }


            $video.css({
                width : $image.width(),
                height : height,
                display: 'block'
            });

            $image.hide();
            $video.show();
            $video.get(0).play();

        },

        onVideoLeave : function () {
/*
            if(!this.isVideoSupport('h264')){
                return false;
            }
*/
            var $video = this.ui.link.find('video');
            var $image = this.ui.link.find('.img-item');
            $image.show();

            var player = $video.get(0);
            player.pause();
            player.currentTime = 0;
            $video.hide();
        },

        serializeData: function () {
            var data = LayoutView.prototype.serializeData.apply(this);

            return data;
        }

    });

});
